import React from 'react';

export const SliderView: React.FC = () => {
    return <p>SliderView</p>;
};
